$(document).ready(function () {
  if ($('.js-product-samples').length) {
    $('.js-product-samples').removeClass('sample-disabled');
  }



  if ($('.tabs--items').length) {
    $('.tabs--item').first().addClass('active');

    $('.tabs--items').each(function () {
      $('.tabs--item:first-of-type').addClass('active');
      $('.tabs--item.wand-guide').removeClass('active');
      $('.tabs--item.motor-guide').removeClass('active');
    });

    $('.videos').each(function () {
      $('.videos--video:first-of-type').addClass('active');
      $('.videos--video').not(':first-of-type').hide();
    });

    $('.tabs--item').on('click', function () {
      var dataVid = $(this).data('vid');
      console.log(dataVid);

      if (dataVid == 'wand-guide' || dataVid == 'motor-guide') {

      } else {
        $(this).closest('.tabs').find('.tabs--item').removeClass('active');
        $(this).addClass('active');
        $(this).closest('.measure-install-videos--section-half').find('.videos--video').fadeOut().removeClass('active');
        $(this).closest('.measure-install-videos--section-half').find('[data-vid="' + dataVid + '"]').fadeIn().addClass('active');
      }

    });
  };

  if ($('body').attr('id') == 'samples') {
    $('.productitem--image-link').addClass('disabled');
    $('.productitem--image-link').attr('disabled', true);
    $('.productitem--title a').addClass('disabled');
    $('.productitem--title a').attr('disabled', true);
  }

  $('.mobile-nav--items-item').on('click', function () {
    $(this).closest('.mobile-nav--items').find('.mobile-nav--items-item').removeClass('active');
    $(this).addClass('active');
    var dataCtrl = $(this).data('ctrl');
    $(this).closest('.measure-install-videos--section').find('.measure-install-videos--section-half').removeClass('active');
    $(this).closest('.measure-install-videos--section').find('.measure-install-videos--section-half.' + dataCtrl).addClass('active');
  });

  //Product finder quiz

  $('.product-finder .start').on('click', function () {
    $('.product-finder--intro').fadeOut();
    $('.product-finder--questions').show();
    $('.product-finder--questions').find('[data-question="1"]').fadeIn();
    $('.product-finder--restart').fadeIn();
  });

  $('.product-finder--questions-question-answers .answer').on('click', function () {
    //get current question number
    //var currentQuestion = $(this).closest(".product-finder--questions-question").data('question');
    //find next question
    var relatedQuestion = $(this).data('related-question');
    //hide this question
    $(this).closest('.product-finder--questions-question').fadeOut();

    $('body,html').animate({ scrollTop: 0 }, 800);

    //show next question
    $('.product-finder--questions').find('[data-question="' + relatedQuestion + '"]').fadeIn();
    if ($('.product-finder--questions').find('[data-question="' + relatedQuestion + '"]').hasClass('result')) {
      $('.product-finder--questions').find('[data-question="' + relatedQuestion + '"]').addClass('open');
    }

  });

  //restart button
  $('.product-finder .restart').on('click', function () {
    $('.product-finder--intro').fadeIn();
    $('.product-finder--questions').find('[data-question="1"]').fadeOut();
    $('.back').attr('data-related-question', 1);
    $('.product-finder--restart').fadeOut();
    $('.product-finder--questions-question').fadeOut();
    $('.product-finder--questions-question.result.open').removeClass('open');
  });


  $('.geoip-button-block').prepend('<a href="https://www.bloccommercialblinds.com/" class="geoip-btn">UK Trade Site</a>');
});